<template>
  <section>
    <h5 class="mt-4 mb-4">{{$_strings.order.RUTE_INFO}}</h5>
    <v-data-table
      :headers="headerRuteInfo"
      calculate-widths
      hide-default-footer
      :items="itemsRuteInfo"
      class="elevation-1 rounded"
    >
      <template v-slot:[`item.multiPick`]="{item}" >
        <p v-if="item.itemsMultiPick.length === 0"> - </p>
        <p v-for="(itemMultiPick, index) in item.itemsMultiPick" :key="index">
          {{index + 1}} - {{itemMultiPick.locationName}}
        </p>
      </template>
      <template v-slot:[`item.multiDrop`]="{item}" >
        <p v-if="item.itemsMultiDrop.length === 0"> - </p>
        <p v-for="(itemMultiDrop, index) in item.itemsMultiDrop" :key="index">
          {{index + 1}} - {{itemMultiDrop.locationName}}
        </p>
      </template>
      <template v-slot:[`item.estimateArrival`]="{item}">
        <p class="ma-0">{{dateFormat(item.estimateArrival)}}</p>
        <p v-if="item.estimateArrival">{{timeFormat(item.estimateArrival)}}</p>
      </template>
      <template v-slot:[`item.note`]={item}>
        <pre><p class="ma-0">{{item.note ? item.note : '-'}}</p></pre>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dateFormat, timeFormat } from '../../../helper/commonHelpers';

export default {
  props: {
    itemsRuteInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // Rute Info
      headerRuteInfo: [
        {
          text: this.$_strings.order.ORIGIN,
          value: 'originLocationName',
          class: 'black--text amber accent-3',
          sortable: false,
        },
        {
          text: this.$_strings.order.DESTINATION,
          value: 'destinationLocationName',
          class: 'black--text amber accent-3',
          sortable: false,
        },
        {
          text: this.$_strings.order.MULTIPICK,
          value: 'multiPick',
          class: 'black--text amber accent-3',
          sortable: false,
        },
        {
          text: this.$_strings.order.MULTIDROP,
          value: 'multiDrop',
          class: 'black--text amber accent-3',
          sortable: false,
        },
        {
          text: this.$_strings.order.ETA,
          value: 'estimateArrival',
          width: '200px',
          class: 'black--text amber accent-3 text-uppercase',
          sortable: false,
        },
        {
          text: this.$_strings.order.NOTE,
          value: 'note',
          class: 'black--text amber accent-3',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    dateFormat,
    timeFormat,
  },
};
</script>
